import React from 'react';
import { CopyToClipboardComponents } from '../../../ReusableComponents/UtilityComponents';
import ShowMultiValues from './ShowMultiValues';

export const ProposalLogsHeaderData = [
  {
    id: 1,
    label: 'proposal_name',
    input: 'proposalName',
  },
  {
    id: 2,
    label: 'proposal_id',
    input: 'proposalId',
  },
  {
    id: 3,
    label: 'generated_at',
    input: 'generatedAt',
    isDate: true,
    dateFormat: 'DD/MM/YYYY HH:mm',
  },
  {
    id: 4,
    label: 'generated_by',
    input: 'generatedBy',
  },
  {
    id: 5,
    label: 'staff_id',
    input: 'generatedById',
  },
  {
    id: 6,
    label: 'team',
    component: (row) => (
      <ShowMultiValues
        values={row.generatorDetails}
        itemRender={(item) => (
          <span className='table-capsule mr-1 fw-simi-bold'>
            {item.teamName}
          </span>
        )}
      />
    ),
  },
  {
    id: 7,
    label: 'business_group',
    component: (row) => (
      <ShowMultiValues
        values={row.generatorDetails}
        itemRender={(item) => (
          <span className='table-capsule mr-1 fw-simi-bold'>
            {item.businessGroup}
          </span>
        )}
      />
    ),
  },
  {
    id: 8,
    label: 'branch',
    input: 'generatedByBranch',
  },
  {
    id: 9,
    label: 'shared_to_type',
    component: (row) => (
      <ShowMultiValues
        values={row.receivers}
        itemRender={(item) => (
          <span className='table-capsule mr-1 fw-simi-bold'>
            {item.sharedToType}
          </span>
        )}
      />
    ),
  },
  {
    id: 10,
    label: 'shared_to_name',
    component: (row) => (
      <ShowMultiValues
        values={row.receivers}
        itemRender={(item) => (
          <span className='table-capsule mr-1 fw-simi-bold'>
            {item.sharedToName}
          </span>
        )}
      />
    ),
  },
  {
    id: 11,
    label: 'shared_to_id',
    component: (row) => (
      <ShowMultiValues
        values={row.receivers}
        itemRender={(item) => (
          <CopyToClipboardComponents
            data={item.sharedToId}
            childrenData={item.sharedToId}
            CustomizationClassName='copy-value'
          />
        )}
      />
    ),
  },
  {
    id: 12,
    label: 'proposal_type',
    input: 'proposalType',
    component: (row) => (
      <span
        className={`proposalChip ${
          row.proposalType?.toLowerCase() === 'classic'
            ? 'classicChip'
            : 'premiumChip'
        }`}
      >
        {row.proposalType}
      </span>
    ),
  },
  {
    id: 13,
    label: 'proposal_mode',
    input: 'proposalMode',
    component: (row) => (
      <span
        className={`proposalModeChip ${
          row.proposalMode?.toLowerCase() === 'light' ? 'lightChip' : 'darkChip'
        }`}
      >
        {row.proposalMode}
      </span>
    ),
  },
  {
    id: 14,
    label: 'unit_ref_numbers',
    component: (row) => (
      <ShowMultiValues
        values={row.unitsRefNumbers}
        itemRender={(item) => (
          <CopyToClipboardComponents
            data={item.unitRefNumber}
            childrenData={item.unitRefNumber}
            CustomizationClassName='copy-value'
          />
        )}
      />
    ),
  },
  {
    id: 15,
    label: 'property_names',
    input: 'propertyName',
    component: (row) => (
      <span className='property-name-chip'>{row?.propertyName}</span>
    ),
  },
  {
    id: 16,
    label: 'platform',
    input: 'platformType',
  },
];
